import http, { getBase, url } from '../http'
const API_URL = "employee"

class EmployeeAPI {
  async createEmployee(employee) {
    try {
      const response = await fetch(`${getBase()}${API_URL}/save`, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(employee),
      })

      let data = null
      try {
        data = await response.json()
      } catch (e) {
        data = null
      }

      if (data && typeof data === 'object') {
        return {
          ...data,
          _status: response.status,
          _ok: response.ok,
        }
      }

      return {
        message: typeof data === 'string' ? data : 'Respuesta vacia del servidor',
        _status: response.status,
        _ok: response.ok,
      }
    } catch (error) {
      return {
        message: 'No se pudo conectar con el servidor',
        error: error && error.message ? error.message : String(error),
        _status: 0,
        _ok: false,
      }
    }
  }

  async getAllEmployees() {
    const response = await http(`${API_URL}`, 'GET')
    return await response
  }

  async allEmployees() {
    const response = await http(`allEmployees`, 'GET')
    return await response
  }

  async getEmployee(employeeId) {
    const response = await http(`${API_URL}/list/${employeeId}`, 'GET')
    return await response
  }

  async getUser(email) {
    const { employee } = await http(`${API_URL}/email/${email}`)
    return employee
  }

  async updateEmployee(data) {
    try {
      const response = await fetch(`${getBase()}${API_URL}/update`, {
        method: 'PUT',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })

      let body = null
      try {
        body = await response.json()
      } catch (e) {
        body = null
      }

      if (body && typeof body === 'object') {
        return { ...body, _status: response.status, _ok: response.ok }
      }

      return {
        message: typeof body === 'string' ? body : 'Respuesta vacia del servidor',
        _status: response.status,
        _ok: response.ok,
      }
    } catch (error) {
      return {
        message: 'No se pudo conectar con el servidor',
        error: error && error.message ? error.message : String(error),
        _status: 0,
        _ok: false,
      }
    }
  }

  async setSSOIDbyEmail(email, idsso) {
    const response = await http(`${API_URL}/email`, 'POST', {
      email: email,
      idsso: idsso
    })
    return response
  }

  async getEmployeesByCompany(id, page = 1, search = '') {
    const response = await http(`${API_URL}/company/${id}?page=${page}&search=${search}`, 'GET')
    return response || null
  }

  async getAll(companyID) {
    const response = await http(`${API_URL}/for_companies/${companyID}`, 'GET')
    return response || null
  }

  async getEmployeesSSObyCompany(id) {
    const { employee } = await http(`${API_URL}/company_sso/${id}`, 'GET')
    return employee || null
  }

  async getEmployeeWithSGSST(id) {
    const response = await http(`${API_URL}/sgsst/${id}`, 'GET')
    return response[1] || null
  }

/*   async importEmployees(file) {
    return null
  } */

  async importEmployees(companyID, file) {
    const response = await http(`upload-employee/${companyID}`, 'POST', {
      file:file
    })
    return response
  }

  async getEmployeesOcupationalMedical(CompanyID) {
    const response = await http(`employee/for_companies/${CompanyID}`, 'GET')
    return response || null
  }

  async AllEmployeesForCompanyNotcontratisNotPaginate(CompanyID) {
    const response = await http(`employee/for_companies_dos/${CompanyID}`, 'GET')
    return response || null
  }

  async getEmployeesPromocion(CompanyID) {
    const response = await http(`employee/for_companies/${CompanyID}`, 'GET')
    return response || null
  }

  async AllEmployeesForCompanyActive(CompanyID) {
    const response = await http(`employee/company/is_active/${CompanyID}`, 'GET')
    return response || null
  }

  getExportExcelUrl(companyID, status = 'all', companyName = '') {
    const s = ['active', 'inactive', 'all'].includes(status) ? status : 'all'
    const qs = companyName ? `?company_name=${encodeURIComponent(companyName)}` : ''
    return url(`${API_URL}/export/excel/${companyID}/${s}${qs}`)
  }

  getExportPdfUrl(companyID, status = 'all', companyName = '') {
    const s = ['active', 'inactive', 'all'].includes(status) ? status : 'all'
    const qs = companyName ? `?company_name=${encodeURIComponent(companyName)}` : ''
    return url(`${API_URL}/export/pdf/${companyID}/${s}${qs}`)
  }

  // Formato de carga masiva generado por el backend (siempre en sync con la tabla).
  // examples > 0 pre-llena N filas de ejemplo validas para probar sin diligenciar a mano.
  getTemplateUrl(companyID, examples = 0) {
    const qs = examples > 0 ? `?ejemplos=${examples}` : ''
    return url(`${API_URL}/template/${companyID}${qs}`)
  }

}

export default new EmployeeAPI()